module.exports = __webpack_public_path__ + "img/lock.66600e87.png";